import { createAction } from "@reduxjs/toolkit";

export const updateTable = createAction<any>("table/update");
